import React from 'react';
import {Container, Alert} from 'react-bootstrap';
import {SubscriptionPricingTable} from './billing';

export default function ActivatePage(): React.JSX.Element {
  return (
    <Container className='my-5'>
      <Alert variant='info'>
        <h1>Account not activated</h1>
        <p>
          Your account hasn't been activated yet. Please choose between the
          following subscription options to activate your account.
        </p>
      </Alert>

      <SubscriptionPricingTable showTrial={true} />
    </Container>
  );
}
